import Login from '../pages/Login';
import DashboardLayout from "../layout/dashboard/DashboardLayout.vue";
import Dashboard from './../pages/Dashboard';
import DrawingMain from './../pages/Drawing/Main';
import DrawingArticle from './../pages/Drawing/Article';
import Documents from './../pages/Documents';
import Report from './../pages/Report';
import MonitoringOrder from './../pages/MonitoringOrder';
import FrontOffice from './../pages/FrontOffice';
import TransportApplication from './../pages/TransportApplication';
import DrawingLayout from './../pages/DrawingLayout.vue';

import Monitoring from './../pages/Monitoring';
import About from './../pages/About';
import Calendar from './../pages/Calendar';
import Profile from "../pages/Profile";
import DisplayDraw from "../pages/DisplayDraw";

import Quality from "../pages/Quality";
import Quality2 from "../pages/Quality2";
import productDTO from "../pages/ProductDTO";

const routes = [
    {
        path: "/",
        name: "login",
        component: Login,
        meta: { title: 'Login' },
    },
    {
        path: '/quality/:serial?',
        name: 'quality',
        component: Quality,
        meta: { title: 'Quality' }
    },
    {
        path: '/qua/:serial?',
        name: 'quality2',
        component: Quality2,
        meta: { title: 'Quality' }
    },
    /*{
        path: '/product-dto',
        name: 'product-dto',
        component: productDTO,
        meta: { title: 'productDTO' }
    },*/
    {
        path: '/displaydraw',
        name: 'displaydraw',
        component: DisplayDraw,
        meta: { title: 'DisplayDraw' }
    },
    {
        path: "/dashboard",
        name: "dashboard-layout",
        redirect: { 
            name: 'dashboard' 
        },
        component: DashboardLayout,
        meta: { title: 'Dashboard' },
        children: [
            {
                path: 'main',
                name: 'dashboard',
                component: Dashboard,
                meta: { title: 'Dashboard' }
            },
            {
                path: 'drawing',
                name: 'drawing-layout',
                component: DrawingLayout,
                redirect: { name: 'drawing-main' },
                meta: { title: 'Drawing 0' },
                children: [
                    {
                        path: 'main',
                        name: 'drawing-main',
                        component: DrawingMain,
                        meta: { title: 'Search by structure' }
                    },
                    {
                        path: 'article',
                        name: 'drawing-article',
                        component: DrawingArticle,
                        meta: { title: 'Search by article' }
                    },
                ]
            },
            {
                path: 'documents',
                name: 'documents',
                component: Documents,
                meta: { title: 'Documents' }
            },
            {
                path: 'report',
                name: 'report',
                component: Report,
                meta: { title: 'Report' },
                children: [
                    {
                        path: 'monitoring-order',
                        name: 'monitoring-order',
                        component: MonitoringOrder,
                        meta: { title: 'Monitoring' }
                    },
                    {
                        path: 'report/front-office',
                        name: 'front-office',
                        component: FrontOffice,
                        meta: { title: 'Front Office' }
                    },
                    {
                        path: 'report/transport-applications',
                        name: 'transport-application',
                        component: TransportApplication,
                        meta: { title: 'Transport' }
                    },
                ]
            },
            {
                path: 'monitoring',
                name: 'monitoring',
                component: Monitoring,
                meta: { title: 'Monitoring' }
            },
            {
                path: 'about',
                name: 'about',
                component: About,
                meta: { title: 'About' }
            },
            {
                path: 'calendar',
                name: 'calendar',
                component: Calendar,
                meta: { title: 'Calendar' }
            },
            {
                path: 'profile',
                name: 'profile',
                component: Profile,
                meta: { title: 'Profile' }
            },
        ]
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js